import React, { useState, useEffect } from 'react';

function LandscapeWarning() {
    const [isLandscape, setIsLandscape] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDeviceAndOrientation = () => {
            // Check if device is mobile using user agent and screen size
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent) 
                && window.outerWidth <= 1024;
            
            setIsMobile(isMobileDevice);
            setIsLandscape(window.innerWidth > window.innerHeight);
        };

        // Check initially
        checkDeviceAndOrientation();

        // Add resize listener
        window.addEventListener('resize', checkDeviceAndOrientation);

        // Cleanup
        return () => window.removeEventListener('resize', checkDeviceAndOrientation);
    }, []);

    if (!isMobile || !isLandscape) return null;

    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-200 bg-opacity-75 z-[9999] items-center justify-center  align-middle">
            <div className="bg-white rounded-lg p-8 max-w-sm text-center shadow-xl mx-auto my-auto mt-5">
                <div className="text-5xl mb-6">📱</div>
                <div className="text-4xl mb-4">
                    <i className="fas fa-rotate-left" aria-hidden="true"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Please Rotate Your Device</h3>
                <p className="text-gray-600 text-lg">
                    For the best experience, please rotate your device to portrait mode.
                </p>
            </div>
        </div>
    );
}

export default LandscapeWarning; 